import { Box } from "@mui/material"

// A compact segmented button set used in the top bar for period selection.
// options: [{ key, label }]. value/onChange drive the selection.
export const SegmentedPeriod = ({ value, onChange, options }) => (
  <Box sx={{ display: "flex", bgcolor: "#F1F3F7", border: "1px solid #E6E8F0", borderRadius: 2.5, p: "3px", gap: "2px" }}>
    {options.map(o => {
      const active = value === o.key
      return (
        <Box
          key={o.key}
          role="button"
          tabIndex={0}
          onClick={() => onChange(o.key)}
          onKeyDown={e => (e.key === "Enter" || e.key === " ") && onChange(o.key)}
          sx={{
            fontSize: 12.5,
            fontWeight: 600,
            px: 1.5,
            py: 0.75,
            borderRadius: 1.75,
            cursor: "pointer",
            whiteSpace: "nowrap",
            color: active ? "#fff" : "#65748B",
            bgcolor: active ? "#12131A" : "transparent",
            "&:hover": active ? {} : { color: "#12131A" },
          }}
        >
          {o.label}
        </Box>
      )
    })}
  </Box>
)

export default SegmentedPeriod
